import { useState } from "react";
import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { maskPrivateKey } from "../serviceAccountUtils.js";

export function ServiceAccountKeyCell({ value, masked = false, label }) {
  const { c } = useThemeSlice();
  const [copied, setCopied] = useState(false);
  const display = masked ? maskPrivateKey(value) : value;

  const copy = async () => {
    if (!value || masked) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
      <code
        title={masked ? "Private key is hidden" : value}
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: 11.5,
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          color: masked ? c.sub : c.text,
          wordBreak: "break-all",
          lineHeight: 1.4,
        }}
      >
        {display || "—"}
      </code>
      {!masked && value && (
        <button type="button" onClick={copy} aria-label={`Copy ${label}`} style={copyBtn(c)}>
          {copied ? "Copied" : "Copy"}
        </button>
      )}
    </div>
  );
}

function copyBtn(c) {
  return {
    height: 26,
    padding: "0 8px",
    borderRadius: 6,
    border: `1px solid ${c.cardBdr}`,
    background: c.card,
    color: c.mid,
    fontSize: 10,
    fontWeight: 700,
    cursor: "pointer",
    flexShrink: 0,
    whiteSpace: "nowrap",
  };
}
